import { GPTModels, MaxValueOptions, SettingData } from './types';

export const gptModels: GPTModels[] = [
  { value: GPTModels.GPT4o, label: 'GPT-4o' },
  { value: GPTModels.GPT4oMINI, label: 'GPT-4o-mini' },
  /*   { value: GPTModels.GPT45PREVIEW, label: 'GPT-4.5-preview' }, */ // TODO: Update this when GPT-4.1 is released
  { value: GPTModels.GPT3Mini, label: 'O3-mini' },
  { value: GPTModels.GPT01, label: 'O1' },
  { value: GPTModels.CLAUDE3SONNET, label: 'Claude 3 Sonnet (Beta)' },
  { value: GPTModels.CLAUDE35SONNET, label: 'Claude 3.5 Sonnet (Beta)' },
  { value: GPTModels.CLAUDE37SONNET, label: 'Claude 3.7 Sonnet (Beta)' },
  { value: GPTModels.LLAMA3_1_70B, label: 'Llama 3.1 70B' },
  { value: GPTModels.LLAMA3_1_405B, label: 'Llama 3.1 405B' },
  { value: GPTModels.LLAMA4_SCOUT_17B, label: 'Llama 4 Scout 17B' },
  { value: GPTModels.LLAMA4_MAVERICK_17B, label: 'Llama 4 Maverick 17B FP8' },
  { value: GPTModels.DEEPSEEK_R1, label: 'DeepSeek R1' },
  { value: GPTModels.DEEPSEEK_V3, label: 'DeepSeek V3' },
  { value: GPTModels.GEMINI_2_5_PRO, label: 'Gemini 2.5 Pro' },
  { value: GPTModels.GROK3, label: 'Grok-3 (Latest)' },
];

export const maxValueOptions: MaxValueOptions[] = [
  { value: MaxValueOptions.SHORT, label: 'Short' },
  { value: MaxValueOptions.MEDIUM, label: 'Medium' },
  { value: MaxValueOptions.LONG, label: 'Long' },
];

export const initialSettingsValue: SettingData = {
  basePrompt: `You're an intelligent assistant. You are focused on giving precise and helpful answers. Excel in multi-turn conversations and ask for clarification if needed.`,
  gptModel: GPTModels.GPT4o,
  maxTokens: MaxValueOptions.SHORT,
  maxInputLength: MaxValueOptions.SHORT,
  temperature: 0.1,
  aiName: 'AI Agent',
  company: null,
  isRestricted: false,
  isImageSharingEnabled: true,
  isLearnMoreEnabled: true,
  followUpQuestionEnabled: false,
  customDoNotKnowMessage: null,
  limiter: {
    alertText: 'Too many messages in a row',
    limit: 20,
    window: 240,
  },
  collectUserData: {
    status: false,
    after: 5,
    email: {
      status: true,
      required: true,
    },
    phone: {
      status: false,
      required: false,
      countryCode: null,
    },
    fullName: {
      status: false,
      required: false,
    },
  },
  schedule: {
    status: false,
    timezone: 'Europe/London',
    dates: [
      {
        days: 'everyday',
        startTime: '08:30',
        endTime: '17:30',
      },
    ],
  },
};
